import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { doc, onSnapshot, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { useAuth } from '../AuthContext';
import ImageUploader from '../components/ImageUploader';
import './ExperienceDetailPage.css';
import { useTranslation } from 'react-i18next';


const ExperienceDetailPage = () => {
  const { experienceId } = useParams();
  const { currentUser } = useAuth();
  const { i18n } = useTranslation();
  const [experienceData, setExperienceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    setLoading(true);
    setError(null);
    if (!experienceId) { setError("ID esperienza mancante."); setLoading(false); return; }
    const docRef = doc(db, 'experiences', experienceId);

    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setExperienceData({ id: docSnap.id, ...data });
        const lang = i18n.language;
        const fallbackLang = 'it';
      } else {
        setError("Esperienza non trovata.");
      }
      setLoading(false);
    }, (err) => {
      setError("Errore nel caricamento dei dati.");
      setLoading(false);
    });
    return () => unsubscribe();
  }, [experienceId, i18n.language]);

  const handleImageUpdate = async (field, newUrl) => {
    if (!currentUser) return;
    const experienceRef = doc(db, 'experiences', experienceId);
    try {
        await setDoc(experienceRef, { [field]: newUrl, updatedAt: serverTimestamp() }, { merge: true });
    } catch (error) {
        console.error("Errore aggiornamento immagine:", error);
        alert("Impossibile aggiornare l'immagine.");
    }
  };
  
  const handleDetailContentImageUpdate = async (index, newUrl) => {
      if (!currentUser || !experienceData || !experienceData.detailContent) return;
      const newContent = JSON.parse(JSON.stringify(experienceData.detailContent));
      if (newContent[index]) {
          newContent[index].value = newUrl;
          await handleImageUpdate('detailContent', newContent);
      }
  };

  const renderContent = () => {
    if (loading) return null;
    if (error) return <div className="container form-status error">{error}</div>;
    if (!experienceData) return <div className="container no-content-text">Dati non disponibili.</div>;

    const lang = i18n.language;
    const fallbackLang = 'it';
    const title = experienceData.title?.[lang] || experienceData.title?.[fallbackLang] || 'Dettaglio Esperienza';
    const description = experienceData.description?.[lang] || experienceData.description?.[fallbackLang] || 'Dettagli sull\'esperienza';

    return (
      <div className="experience-detail-page">
        <section className="page-header"><h1>{title}</h1></section>
        <section className="content-section">
          <div className="container">
              <div className="main-detail-image-container">
                  {currentUser ? (
                      <ImageUploader currentImageUrl={experienceData.imageUrl} onUploadComplete={(url) => handleImageUpdate('imageUrl', url)} folderPath="experiences/main"/>
                  ) : (
                      <img src={experienceData.imageUrl || '/placeholder-image.jpg'} alt={`Immagine ${title}`} />
                  )}
                   <div className="image-overlay-description">
                      <p>{description}</p>
                  </div>
              </div>
              <div className="dynamic-content-area">
                  {(experienceData.detailContent || []).map((block, index) => {
                      const blockSize = block.size || (block.type === 'text' ? 'normal' : 'full');
                      const blockClass = `content-block ${block.type}-block size-${blockSize}`;
                      const key = block._id || index; // Usa _id se presente, altrimenti index

                      if (block.type === 'text') {
                          const text = block.value?.[lang] || block.value?.[fallbackLang] || "";
                          return (
                              <div key={key} className={blockClass}>
                                  {text.split('\n').map((line, i) => <p key={i}>{line || <> </>}</p>)}
                              </div>
                          );
                      }
                      if (block.type === 'image') {
                           return (
                              <div key={key} className={blockClass}>
                                  {currentUser ? (
                                      <ImageUploader currentImageUrl={block.value} onUploadComplete={(url) => handleDetailContentImageUpdate(index, url)} folderPath="experiences/details"/>
                                  ) : (
                                       <img src={block.value || '/placeholder-image.jpg'} alt={`Dettaglio ${index + 1}`} onError={(e) => { e.target.onerror = null; e.target.src='/placeholder-image.jpg'}}/>
                                  )}
                              </div>
                          );
                      }
                      return null;
                  })}
                  {(!experienceData.detailContent || experienceData.detailContent.length === 0) && (
                       <p className="no-content-text">(Nessun dettaglio aggiuntivo inserito per questa esperienza)</p>
                  )}
              </div>
              <div className="contact-button-container">
                  <Link to="/contatti" className="cta-button" state={{ requestedService: title }}>{t('buttonRequestInfo')}</Link>
              </div>
          </div>
        </section>
      </div>
    );
  };

  return renderContent();
};

export default ExperienceDetailPage;


